module.exports = __webpack_public_path__ + "media/images/about-logo-afwa-e391d0d2116c5834af1330df4544cd1f.png";